import React, { Component } from 'react';
import { connect } from 'react-redux';

const EllipseIcon = () => {
  return <div className="gsa__result-plane-ellipse">
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 696 326">
      <g fill="rgba(19,31,62,0.15)" stroke="rgba(255,255,255,0.41)" strokeWidth="1" opacity="0.42">
        <ellipse cx="348" cy="163" rx="348" ry="163" stroke="none"/>
        <ellipse cx="348" cy="163" rx="347.5" ry="162.5" fill="none"/>
      </g>
    </svg>
  </div>
}

export default EllipseIcon;
